import { factory, random, sequence } from 'stahlwerk';

export const createSettingValue = factory({
  id: sequence(),
  userId: sequence(),
  validFrom: '2020-01-01',
  validTo: '2020-01-01',
  value: random([true, false, 'whats-up', 1]),
});
